export const Title = ({ title }) => {
    return (
        <>
            <div className='relative'>
                <div className='flex justify-center'>
                    <img className='' src={`${process.env.PUBLIC_URL}/images/title-wood.png`} alt={`header ${title} on wood decoration`} />{' '}
                    <h1 className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center text-gradient-title text-xlg md:text-title font-pop'>
                        {title}
                    </h1>{' '}
                </div>
            </div>
        </>
    )
}

export const SystemTitle = ({ title }) => {
    return (
        <>
            <button onClick={() => {}} className='relative'>
                <div className='flex justify-center'>
                    <img className='' src={`${process.env.PUBLIC_URL}/images/title-wood.png`} alt={title} />{' '}
                    <h1 className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center text-gradient-title text-xlg md:text-title font-pop'>
                        {title}
                    </h1>{' '}
                </div>
            </button>
        </>
    )
}
export const MobileTitle = ({ title }) => {
    return (
        <div className='py-12'>
            <h1 className='block md:hidden text-center text-gradient-title text-lg font-pop'>{title}</h1>
        </div>
    )
}
export const HeaderTitle = ({ title, children }) => {
    return (
        <div className='relative'>
            <img
                className='absolute top-1/2 -translate-x-1/2 left-1/2 -translate-y-1/2'
                src={`${process.env.PUBLIC_URL}/images/header-deco.webp`}
                alt={title}
            />
            {children ? (
                children
            ) : (
                <h1 className='text-header-gradient capitalize px-8 max-width-[500px] absolute top-1/2 -translate-x-1/2 left-1/2 -translate-y-1/2 text-xlg text-center font-pop tracking-tightest'>
                    {title}
                </h1>
            )}
        </div>
    )
}
